import React from 'react';
import { motion } from 'framer-motion';

const MiniWidget = ({ title, icon, onClick }) => {
  return (
    <motion.div
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      className="
        bg-gray-750 
        border border-gray-600 
        rounded-lg 
        flex 
        flex-col 
        items-center 
        justify-center
        cursor-pointer
        hover:border-gray-500
        hover:bg-gray-700
        transition-all
        duration-200
        p-2
      "
      onClick={onClick}
    >
      <div className="text-gray-400 text-lg mb-1">
        {icon}
      </div>
      <div className="text-gray-300 text-xs text-center font-medium">
        {title}
      </div>
    </motion.div>
  );
};

const SubWidget = ({ className = '', miniWidgets = [], hidden = false }) => {
  if (hidden) return null;
  
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
      transition={{ duration: 0.2 }}
      className={`
        bg-gray-800 
        border border-gray-700 
        rounded-lg 
        p-3
        min-h-32
        hover:border-gray-600
        hover:bg-gray-750
        transition-all
        duration-200
        ${className}
      `}
    >
      <div className="grid grid-cols-2 gap-2 h-full">
        {miniWidgets.map((widget, index) => (
          <MiniWidget
            key={index}
            title={widget.title}
            icon={widget.icon}
            onClick={widget.onClick}
          />
        ))}
      </div>
    </motion.div>
  );
};

export default SubWidget;